<script>
import { ToastContainer } from 'svelte-toasts';
import SuccessIcon from '../../icons/SuccessIcon.svelte';
import ErrorIcon from '../../icons/Error.svelte';
import Information from '../../icons/Information.svelte';
import Warning from '../../icons/Warning.svelte';
import Cancel from '../../icons/CancelIcon.svelte';

</script>

<ToastContainer placement="top-center" let:data>
	<!-- Success Toast -->
	{#if data?.type==='success'}
		<div
			class="tw-z-50 tw-rounded-lg tw-border tw-border-solid tw-border-success tw-bg-[#E8FBF2] tw-p-4"
		>
			<div class="tw-flex tw-items-center tw-gap-4">
				<div class="tw-relative">
					<SuccessIcon />
				</div>
				<div class="tw-flex tw-flex-col tw-gap-2">
					<h6
						class="tw-whitespace-nowrap tw-font-inter tw-text-[15px] tw-font-semibold tw-leading-[15px] tw-text-[#171717]"
					>
						SUCCESS
					</h6>
					<p
						class="tw-whitespace-nowrap tw-font-inter tw-text-base tw-font-medium tw-leading-6 tw-text-[#171717]"
					>
						{data?.description}
					</p>
				</div>
				<button type="button" on:click={()=> data?.remove && data?.remove()}>
					<div class="tw-relative">
						<Cancel />
					</div>
				</button>
			</div>
		</div>
	{/if}
	<!-- Error Toast -->
	{#if data?.type==='error'}
		<div
			class="tw-z-50 tw-rounded-lg tw-border tw-border-solid tw-border-danger tw-bg-[#FFECEE] tw-p-4"
		>
			<div class="tw-flex tw-items-center tw-gap-4">
				<div class="tw-relative">
					<ErrorIcon />
				</div>

				<div class="tw-flex tw-flex-col tw-gap-2">
					<h6
						class="tw-whitespace-nowrap tw-font-inter tw-text-[15px] tw-font-semibold tw-leading-[15px] tw-text-[#171717]"
					>
						ERROR
					</h6>
					<p
						class="tw-whitespace-nowrap tw-font-inter tw-text-base tw-font-medium tw-leading-6 tw-text-[#171717]"
					>
						{data.description}
					</p>
				</div>

				<button type="button" on:click={()=>data?.remove && data?.remove()}>
					<div class="tw-relative">
					<Cancel />
					</div>
				</button>
			</div>
		</div>
	{/if}
	<!-- Warning Toast -->
	{#if data?.type==='warning'}
		<div
			class="tw-z-50 tw-rounded-lg tw-border tw-border-solid tw-border-warning tw-bg-[#FFF4EB] tw-p-4"
		>
			<div class="tw-flex tw-items-center tw-gap-4">
				<div class="tw-relative"></div>
				<div class="tw-flex tw-flex-col tw-gap-2">
					<h6
						class="tw-whitespace-nowrap tw-font-inter tw-text-[15px] tw-font-semibold tw-leading-[15px] tw-text-[#171717]"
					>
						WARNING
					</h6>
					<p
						class="tw-whitespace-nowrap tw-font-inter tw-text-base tw-font-medium tw-leading-6 tw-text-[#171717]"
					>
						{data.description}.
					</p>
				</div>
				<div class="tw-relative">
				<Warning />
				</div>
			</div>
		</div>
	{/if}
	<!-- Info Toast -->
	{#if data?.type==='info'}
		<div
			class="tw-z-50 tw-rounded-lg tw-border tw-border-solid tw-border-primary tw-bg-primary-light tw-p-4"
		>
			<div class="tw-flex tw-items-center tw-gap-4">
				<div class="tw-relative"></div>
				<div class="tw-flex tw-flex-col tw-gap-2">
					<h6
						class="tw-whitespace-nowrap tw-font-inter tw-text-[15px] tw-font-semibold tw-leading-[15px] tw-text-[#171717]"
					>
						INFO
					</h6>
					<p
						class="tw-whitespace-nowrap tw-font-inter tw-text-base tw-font-medium tw-leading-6 tw-text-[#171717]"
					>
						{data.description}
					</p>
				</div>
				<div class="tw-relative">
					<Information />
				</div>
			</div>
		</div>
	{/if}
</ToastContainer>
